import { Component, ChangeDetectionStrategy, HostBinding, ViewEncapsulation, Input, OnInit, ElementRef } from '@angular/core';
import { UxAppShellService } from '@eui/core';

@Component({
    selector: 'eui-header-environment',
    templateUrl: './header-environment.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiHeaderEnvironmentComponent implements OnInit {

    @HostBinding() class = 'eui-header-environment';

    constructor(
        private asService: UxAppShellService,
        private elRef: ElementRef,
    ) {}

    ngOnInit() {
        this.asService.setState({
            ...this.asService.state,
            hasHeaderEnvironment: true,
            environmentValue: this.elRef.nativeElement.innerHTML,
        });
    }

}
